import { createEditables } from '@dabble/data/editables';
import { projectMetasStore, projectStore } from '@dabble/data/project-data';
import { settingsStore } from '@dabble/data/settings';

export const editables = createEditables({
  projectStore,
  projectMetasStore,
  settingsStore,
});
